// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tab_Tabs__3WIfW","bottomBorder":"Tab_bottomBorder__zaXmD","rightPull":"Tab_rightPull__UuvDd"};